import Vue from 'vue'
import Vuex from 'vuex'

import me from './modules/me'
import home from './modules/home'
import accountList from './modules/account.list'
import linkList from './modules/link.list'
import institutionList from './modules/institution.list'
import institutionDetail from './modules/institution.detail'
import notificationList from './modules/notification.list'
import roundupList from './modules/roundup.list'
import transactionList from './modules/transaction.list'
import groupList from './modules/group.list'
import groupDetail from './modules/group.detail'
import events from './modules/events'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		me,
		home,
		linkList,
		accountList,
		institutionList,
		institutionDetail,
		notificationList,
		roundupList,
		transactionList,
		groupDetail,
		groupList,
		events
	},
	strict: true
})
